<div class="nav-pills">
  <div class="nav-pills-inner" #navPills>
    <div
      *ngFor="let item of items"
      class="nav-pills-inner-item-container nav-pills-item">
      <ng-container [ngTemplateOutlet]="item.tpl"></ng-container>
    </div>
  </div>
</div>
